<template>
    <div class="header-warp">
        <header
                id="subHeader"
                class="header">
            <h1 >{{ title }}</h1>
            <span
                    class="back"
                    @click="goBack" />
        </header>
    </div>
</template>

<script>
  // import NativeAPI from 'native-api'
  import NativeSdk from "@/utils/nativeSdk"

  export default {
    props: {
      title: {
        type: String,
        default: '',
      },
    },
    data() {
      const isApp = navigator.userAgent.indexOf('chesupai') > -1 || navigator.userAgent.indexOf('chesuda') > -1 || navigator.userAgent.indexOf('Guazi') > -1
      return {
        isApp: !!isApp,
      }
    },
    methods: {
      goBack() {
        if (this.isApp) {
          // NativeAPI.register('back', (data, responseCallback) => {
          //   responseCallback('{preventDefault: false}')
          // })
          NativeSdk.back();
        } else {
          this.$router.go(-1)
        }
      },
    },
  }
</script>

<style scoped lang="less">
@import "./index";
</style>
